export function getOppositeGender(gender) {
  if (gender === "男") return "女";
  if (gender === "女") return "男";
  return "";
}

export function getOppositeGenderLabel(gender) {
  const opposite = getOppositeGender(gender);
  return opposite ? `仅推荐异性：${opposite}` : "";
}
